// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

export enum Load {
    DONE,
    LOADING,
    FAILED,
}

export const USER_GROUP_POPOVER_OPENING_DELAY = 300;
export const USER_GROUP_POPOVER_CLOSING_DELAY = 500;
